<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 16:49:31
 * @Description: 实人认证(未使用)
-->
<template>
	<div>实人认证</div>
</template>

<script>
export default {
	name: "Authentica",
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>

<style lang="scss" scoped></style>
